import React from 'react'
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';


export default function Paginations({ data, currentPage, handlePaginate, postPerPage,pageCount,control }) {
  return (
      <Stack spacing={2}>
        <Pagination
          className='single-paginate'
          siblingCount={1}
          // style={pageCount < postPerPage + 1 ? { display: "none" } : null}
          count={pageCount} // paginaton length için gereken bölüm
          onChange={handlePaginate}
          page={currentPage}
          color="primary"
          defaultPage={1}
          hideNextButton={true}
          hidePrevButton={true}
        />
      </Stack>
  )
}
